import { createContext } from "react";
/**
 * Context for visible layout
 *
 * Can be used to access the visible layout, if any component needs the complete layout state
 */
export const AllLayoutCellMapContext = createContext(new Map());
AllLayoutCellMapContext.displayName = "AllLayoutCellMapContext";
/**
 * Context for visible layout
 *
 * Can be used to access the visible layout, if any component needs the complete layout state
 */
export const VisibleLayoutCellMapContext = createContext(new Map());
VisibleLayoutCellMapContext.displayName = "VisibleLayoutCellMapContext";
//# sourceMappingURL=LayoutCellMapContext.js.map